import React from 'react';
import { useSelector } from 'react-redux';

import { RootState } from 'store';

import ApplicationOverlayContent from 'components/ApplicationLayout/ApplicationOverlayContent';
import FlightsExchangeOption from 'components/FlightsExchangeOption';
import HeaderMobile from 'components/HeaderMobile';
import useStoreTranslation from 'hooks/useStoreTranslation';

interface Props {
  show: boolean;
  onClose: () => void;
  onContinue: (changeDeparture: boolean, changeArrival: boolean) => void;
}

const FlightsExchangeOptionContainer = ({ show, onClose, onContinue }: Props) => {
  const { t } = useStoreTranslation();

  const {
    departureCity,
    departureCode,
    arrivalCode,
    departureDate,
    arrivalDate,
    changeDeparture,
    changeArrival,
    originalFlight,
    airFareConditions,
    arrivalCity,
  } = useSelector((state: RootState) => state.flights.changeFlight);

  const search = () => (
    <FlightsExchangeOption
      departureCity={originalFlight?.flightDepartureCity ?? departureCity}
      departureCode={originalFlight?.departurePoint ?? departureCode}
      arrivalCode={originalFlight?.arrivalPoint ?? arrivalCode}
      departureDate={originalFlight?.date ? new Date(originalFlight?.date) : departureDate}
      arrivalDate={originalFlight?.returnDate ? new Date(originalFlight?.returnDate) : arrivalDate}
      onContinue={onContinue}
      defaultChangeDeparture={changeDeparture}
      defaultChangeArrival={changeArrival}
      airFareConditions={airFareConditions}
      arrivalCity={arrivalCity ?? originalFlight?.arrivalPoint ?? arrivalCode}
      travelAirStretch={originalFlight?.travelAirStretch}
    />
  );
  return (
    <>
      <ApplicationOverlayContent sidebar show={show} onClose={onClose} backgroundColor="#f9f9f9">
        <HeaderMobile goBack={onClose} title={t('flightsExchange.option.header')} />
        {search()}
      </ApplicationOverlayContent>
    </>
  );
};

export default FlightsExchangeOptionContainer;
